import React, { useContext, useReducer } from 'react';
import {
    AvatarUrlActionContext,
    AvatarUrlDispatchContext,
    AvatarUrlReducer,
    initialAvatarUrlAction,
} from './AvatarUrlContext';

export const AvatarUrlProvider: React.FunctionComponent<React.PropsWithChildren> = function ({
    children,
}) {
    const [avatarUrlAction, dispatch] = useReducer(AvatarUrlReducer, initialAvatarUrlAction);

    return (
        <AvatarUrlActionContext.Provider value={avatarUrlAction}>
            <AvatarUrlDispatchContext.Provider value={dispatch}>
                {children}
            </AvatarUrlDispatchContext.Provider>
        </AvatarUrlActionContext.Provider>
    );
};

export function useAvatarUrl() {
    return useContext(AvatarUrlActionContext);
}

export function useAvatarUrlDispatch() {
    return useContext(AvatarUrlDispatchContext);
}
